// extracted by mini-css-extract-plugin
export var breadcrumb = "_g-2";
export var breadcrumbArrow = "_g-3";
export var breadcrumbs = "_g-0";
export var link = "_g-4";
export var small = "_g-1";